import React from "react"
import PropTypes from "prop-types"
import ConfirmationModal from "../ConfirmationModal"
import {
  USUARIO_INATIVACAO_TITULO,
  USUARIO_INATIVACAO_BOTAO_CANCELAR,
  USUARIO_INATIVACAO_BOTAO_CONFIRMAR,
  USUARIO_INATIVACAO_BOTAO_PROCESSANDO,
  UsuarioInativacaoModalConteudo,
} from "../UsuarioAcaoModalTexto"

const UsuarioInativacaoConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  lProcessando,
  oImpactoInativacao,
  lCarregandoImpacto,
}) => (
  <ConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    Primeiro={lProcessando ? USUARIO_INATIVACAO_BOTAO_PROCESSANDO : USUARIO_INATIVACAO_BOTAO_CONFIRMAR}
    Segundo={USUARIO_INATIVACAO_BOTAO_CANCELAR}
    danger
    title={USUARIO_INATIVACAO_TITULO}
  >
    <UsuarioInativacaoModalConteudo
      {...(oImpactoInativacao || {})}
      lCarregando={lCarregandoImpacto}
    />
  </ConfirmationModal>
)

UsuarioInativacaoConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  lProcessando: PropTypes.bool,
  oImpactoInativacao: PropTypes.shape({
    nConversasAtivasComoResponsavel: PropTypes.number,
    nFilasComoResponsavel: PropTypes.number,
  }),
  lCarregandoImpacto: PropTypes.bool,
}

UsuarioInativacaoConfirmationModal.defaultProps = {
  lProcessando: false,
  oImpactoInativacao: null,
  lCarregandoImpacto: false,
}

export default UsuarioInativacaoConfirmationModal
